import { useMemo } from "react";
import { useSearchParams } from "react-router";
import { isInvertedRange, parseReportParams } from "./reportParams";

/** Report filters live in the URL so a report can be bookmarked and shared. */
export const useReportParams = () => {
  const [search, setSearch] = useSearchParams();
  const params = useMemo(() => parseReportParams(search, new Date()), [search]);
  const update = (patch: Record<string, string | null>) =>
    setSearch(
      (prev) => {
        const next = new URLSearchParams(prev);
        Object.entries(patch).forEach(([k, v]) =>
          v == null || v === "" ? next.delete(k) : next.set(k, v),
        );
        return next;
      },
      { replace: true },
    );
  return { ...params, rangeInverted: isInvertedRange(search), update };
};
